export default "__VITE_ASSET__mmvzTkbC__"